export default "__VITE_ASSET__DB2IX3fy__"